import Decimal from 'decimal.js';

import { EstateWaterfall_TransferLogItemFragment } from '@/modules/estateWaterfall/graphql/EstateWaterfall.generated';
import { formatCurrencyNoDecimals } from '@/utils/formatting/currency';

import { EdgeLabelCard } from '../edgeLabelCard.component';
import { CardConfig } from './types';

interface PouroverCardParams {
  associatedPouroverDispositions: EstateWaterfall_TransferLogItemFragment[];
  sourceEntityName: string;
  targetEntityName: string;
  decedentName?: string;
}

export function createPouroverCard({
  associatedPouroverDispositions,
  sourceEntityName,
  targetEntityName,
  decedentName,
}: PouroverCardParams): CardConfig {
  const totalPouroverValue = associatedPouroverDispositions.reduce(
    (acc: Decimal, disposition) => {
      if (!disposition) return acc;
      return acc.plus(disposition.finalTransferAmount || 0);
    },
    new Decimal(0)
  );

  return {
    element: (
      <EdgeLabelCard
        key={`pourover-${sourceEntityName}-${targetEntityName}`}
        title="Pourover provisions"
        description={`${sourceEntityName} pours into ${targetEntityName} upon ${decedentName ?? 'the grantor'}'s death.`}
        rows={[
          {
            label: 'Distribution amount',
            value: formatCurrencyNoDecimals(totalPouroverValue),
          },
        ]}
      />
    ),
    label: 'Pourover',
    value: formatCurrencyNoDecimals(totalPouroverValue),
    variant: 'primary',
  };
}
